import clsx from 'clsx';
import { FC } from 'react';

import styles from './styles.module.css';

const CompletedProjectsPattern: FC = () => {
  return (
    <>
      <div className={clsx(styles.pattern, styles.a)} />
      <div className={clsx(styles.pattern, styles.b)} />
      <div className={clsx(styles.pattern, styles.c)} />
    </>
  );
};

export default CompletedProjectsPattern;
